import { render, staticRenderFns } from "./CampoDataBase.vue?vue&type=template&id=619bcaa5&scoped=true"
import script from "./CampoDataBase.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoDataBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CampoDataBase.vue?vue&type=style&index=0&id=619bcaa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619bcaa5",
  null
  
)

export default component.exports